import React from 'react';
import classes from './academySection.module.css';
import Title from '../../containers/title/title';
import Button from '../../containers/button/button';
import { useNavigate } from 'react-router';
import { getImageUrl } from '../../../utils/imageUrl';

const Academy = (props) => {
    const navigate = useNavigate();
    return (
        <div className={classes.Academy}>
            <Title title={props.academySection?.title}/>
            <div className={classes.DarkEffect} />
            <div className={classes.Background} style={{ backgroundImage: `url(${getImageUrl(props.academySection?.banner_image)})` }}>
                <div>
                    <p dangerouslySetInnerHTML={{ __html: props.academySection?.content}}/>
                    <Button 
                        content={parseInt(localStorage.getItem('language')) === 1 ? "KNOW MORE" : "اعرف المزيد"}
                        onClick={() => navigate('/academy')}
                    />
                </div>
            </div>
        </div>
    )
}
export default Academy;